export default "__VITE_ASSET__BBRTHYNq__"